



















import Vue from 'vue';

export default Vue.extend({
  name: 'HeadBaseLink',
  props: {
    navLink: {
      required: true,
      type: [String, Array],
    },
  },
  data() {
    return {
      isString: false,
    };
  },
  watch: {
    navLink: {
      immediate: true,
      deep: true,
      handler(val: string | Array<string>) {
        if (typeof val === 'string') {
          this.$data.isString = true;
        }
      },
    },
  },
});
